import React from 'react'
import { Icon } from './Icon/Icon'

export function IconAdd() {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 32 32">
      <title>add</title>
      <path d="M16.744 14.669h9.336v2.075h-9.336v9.336h-2.075v-9.336h-9.336v-2.075h9.336v-9.336h2.075z" />
    </svg>
  )
}

export function IconSubtract() {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 32 32">
      <title>subtract</title>
      <path d="M29.333 14.667v2.667h-26.667v-2.667z" />
    </svg>
  )
}

export function IconTrash() {
  return <Icon iconId="trash" size="20" />
}

export function IconClose() {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32">
      <title>close</title>
      <path d="M17.886 16l8.485 8.485-1.886 1.886-8.485-8.485-8.485 8.485-1.886-1.886 8.485-8.485-8.485-8.485 1.886-1.886 8.485 8.485 8.485-8.485 1.886 1.886z" />
    </svg>
  )
}

export function IconCart() {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <title>cart</title>
      <path d="M24 24c1.473 0 2.667 1.194 2.667 2.667s-1.194 2.667-2.667 2.667c-1.48 0-2.667-1.2-2.667-2.667 0-1.48 1.187-2.667 2.667-2.667zM2.667 2.667h4.36l1.253 2.667h19.72c0.736 0 1.333 0.597 1.333 1.333 0 0.227-0.067 0.453-0.16 0.667l-4.773 8.627c-0.453 0.813-1.333 1.373-2.333 1.373h-9.933l-1.2 2.173-0.040 0.16c0 0.184 0.149 0.333 0.333 0.333h15.44v2.667h-16c-1.48 0-2.667-1.2-2.667-2.667 0-0.467 0.12-0.907 0.32-1.28l1.813-3.267-4.8-10.12h-2.667v-2.667zM10.667 24c1.473 0 2.667 1.194 2.667 2.667s-1.194 2.667-2.667 2.667c-1.48 0-2.667-1.2-2.667-2.667 0-1.48 1.187-2.667 2.667-2.667zM22.667 14.667l3.707-6.667h-16.853l3.147 6.667h10z" />
    </svg>
  )
}

export function IconInfo() {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <title>info_outline</title>
      <path d="M16 26.667c5.891 0 10.667-4.776 10.667-10.667s-4.776-10.667-10.667-10.667c-5.891 0-10.667 4.776-10.667 10.667s4.776 10.667 10.667 10.667zM16 29.333c-7.364 0-13.333-5.97-13.333-13.333s5.97-13.333 13.333-13.333c7.364 0 13.333 5.97 13.333 13.333s-5.97 13.333-13.333 13.333zM14.667 14.667h2.667v8h-2.667v-8zM16 12c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z" />
    </svg>
  )
}

export const ArrowRightIcon = () => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <title>arrow_right</title>
      <path d="M21.545 14.667h-16.211v2.667h16.243l-7.479 7.479 1.886 1.886 10.682-10.682-10.682-10.682-1.886 1.886z" />
    </svg>
  )
}

export const ArrowLeftIcon = () => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <title>arrow_left</title>
      <path d="M10.454 14.667h16.211v2.667h-16.243l7.479 7.479-1.886 1.886-10.682-10.682 10.682-10.682 1.886 1.886z" />
    </svg>
  )
}

export const ChevronRightIcon = () => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <title>chevron_right</title>
      <path d="M12.589 10.312l1.886-1.886 7.616 7.616-7.616 7.616-1.886-1.886 5.73-5.73z" />
    </svg>
  )
}

export const ChevronLeftIcon = () => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <title>chevron_left</title>
      <path d="M19.424 10.312l-5.73 5.73 5.73 5.73-1.886 1.886-7.616-7.616 7.616-7.616z" />
    </svg>
  )
}

export const LocationIcon = () => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <title>location</title>
      <path d="M15.6 7.933c2.025 0 3.667 1.642 3.667 3.667 0 0.972-0.386 1.905-1.074 2.593s-1.62 1.074-2.593 1.074c-2.025 0-3.667-1.642-3.667-3.667 0-0.972 0.386-1.905 1.074-2.593s1.62-1.074 2.593-1.074zM15.6 1.333c5.67 0 10.267 4.597 10.267 10.267 0 7.7-10.267 19.067-10.267 19.067s-10.267-11.367-10.267-19.067c0-5.67 4.597-10.267 10.267-10.267zM15.6 4.267c-4.050 0-7.333 3.283-7.333 7.333 0 1.467 0 4.4 7.333 14.241 7.333-9.841 7.333-12.775 7.333-14.241 0-4.050-3.283-7.333-7.333-7.333v0z" />
    </svg>
  )
}

export const UserIcon = () => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <title>user_fill</title>
      <path d="M16 2.667c-7.36 0-13.333 5.973-13.333 13.333s5.973 13.333 13.333 13.333c7.36 0 13.333-5.973 13.333-13.333s-5.973-13.333-13.333-13.333zM16 6.667c2.213 0 4 1.787 4 4s-1.787 4-4 4c-2.213 0-4-1.787-4-4s1.787-4 4-4zM16 25.6c-3.333 0-6.28-1.707-8-4.293 0.040-2.653 5.333-4.107 8-4.107 2.653 0 7.96 1.453 8 4.107-1.72 2.587-4.667 4.293-8 4.293z" />
    </svg>
  )
}

export const SortIcon = () => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <title>sort</title>
      <path d="M22.667 14.667v2.667h-20v-2.667h20zM29.333 6.667v2.667h-26.667v-2.667h26.667zM9.333 22.667v2.667h-6.667v-2.667h6.667z" />
    </svg>
  )
}

export const TruckIcon = () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="Icons/truck" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect id="Box-24pt" x="0" y="0" width="24" height="24" />
      <path
        d="M14.125,5 C14.5710561,5 14.9391861,5.33381804 14.9931822,5.76524613 L15,5.875 L14.999,7.187 L17.2685156,7.1875 C18.0924968,7.1875 18.8246333,7.65448777 19.1768175,8.37665652 L19.2421029,8.52442993 L19.2967441,8.67863161 L20.451,12.373 L21.0469794,12.5725143 C21.8072881,12.8259247 22.3495255,13.4780479 22.473205,14.2507218 L22.4932282,14.4180386 L22.5,14.5884375 L22.5,17.4375 C22.5,17.8835561 22.166182,18.2516861 21.7347539,18.3056822 L21.625,18.3125 L19.211,18.312 L19.1481197,18.4635047 C18.8043271,19.2030115 18.1071053,19.7290575 17.2929382,19.8490142 L17.1167701,19.8684333 L16.9375391,19.875 C16.0345764,19.875 15.2270662,19.3772245 14.8059319,18.6186217 L14.7269429,18.4634937 L14.663,18.312 L8.586,18.312 L8.52308068,18.4635047 C8.17928799,19.2030115 7.48206621,19.7290575 6.66789918,19.8490142 L6.49173102,19.8684333 L6.3125,19.875 C5.40953732,19.875 4.60202718,19.3772245 4.18089284,18.6186217 L4.10190386,18.4634937 L4.038,18.312 L2.875,18.3125 C2.46611525,18.3125 2.12271002,18.0320001 2.02672461,17.6529407 L2.00681785,17.5472539 L2,17.4375 L2,5.875 C2,5.4289439 2.33381804,5.06081386 2.76524613,5.00681785 L2.875,5 L14.125,5 Z M6.3,16.6 C5.85908369,16.6 5.5,16.9590837 5.5,17.4 C5.5,17.8409163 5.85908369,18.2 6.3,18.2 C6.74091631,18.2 7.1,17.8409163 7.1,17.4 C7.1,16.9590837 6.74091631,16.6 6.3,16.6 Z M16.97,16.6 C16.5290837,16.6 16.17,16.9590837 16.17,17.4 C16.17,17.8409163 16.5290837,18.2 16.97,18.2 C17.4109163,18.2 17.77,17.8409163 17.77,17.4 C17.77,16.9590837 17.4109163,16.6 16.97,16.6 Z M13.249,6.75 L3.749,6.75 L3.749,16.562 L4.038,16.562 L4.10191932,16.4114953 C4.47026863,15.6191666 5.24434012,15.0718822 6.13326898,15.0065667 L6.3125,15 C7.2756602,15 8.13021661,15.5663579 8.52309614,16.4115063 L8.586,16.562 L13.249,16.562 L13.249,6.75 Z M17.2685156,8.9375 L14.999,8.937 L14.999,15.961 L15.1026372,15.8344012 C15.5538778,15.3185689 16.2151396,15 16.9375,15 C17.9006602,15 18.7552166,15.5663579 19.1480961,16.4115063 L19.211,16.562 L20.75,16.562 L20.75,14.5884766 C20.75,14.4535966 20.6785627,14.331996 20.5658978,14.2655961 L20.4935933,14.2327157 L19.6485937,13.9375 L16.625,13.9375 C16.1789439,13.9375 15.8108139,13.603682 15.7568178,13.1722539 L15.75,13.0625 L15.75,10.4567249 C15.75,10.0106688 16.083818,9.64253874 16.5152461,9.58854273 L16.625,9.58172489 L18.03,9.581 L17.967252,9.21419715 C17.9231196,9.08301117 17.6466352,8.9664198 17.3712694,8.94213019 L17.2685156,8.9375 Z M18.302,10.812 L17.149,10.812 L17.149,12.312 L18.596,12.312 L18.302,10.812 Z"
        id="Shape"
        fill="#030F1C"
      />
    </g>
  </svg>
)

export const CalendarIcon = () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="Icons/calendar" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect id="Box-24pt" x="0" y="0" width="24" height="24" />
      <g id="calendar" transform="translate(3.000000, 2.000000)" fill="#030F1C">
        <path
          d="M15.2,1.8 L3,1.8 C1.34314575,1.8 0,3.0914863 0,4.68461538 L0,16.4153846 C0,18.0085137 1.34314575,19.3 3,19.3 L15.2,19.3 C16.8568542,19.3 18.2,18.0085137 18.2,16.4153846 L18.2,4.68461538 C18.2,3.0914863 16.8568542,1.8 15.2,1.8 Z M3,3.72307692 L15.2,3.72307692 C15.7522847,3.72307692 16.2,4.15357236 16.2,4.68461538 L16.2,16.4153846 C16.2,16.9464276 15.7522847,17.3769231 15.2,17.3769231 L3,17.3769231 C2.44771525,17.3769231 2,16.9464276 2,16.4153846 L2,4.68461538 C2,4.15357236 2.44771525,3.72307692 3,3.72307692 Z"
          id="Rectangle"
        />
        <path
          d="M12.7,0 C13.2128358,0 13.6355072,0.38604019 13.6932723,0.883378875 L13.7,1 L13.7,4.6 C13.7,5.15228475 13.2522847,5.6 12.7,5.6 C12.1871642,5.6 11.7644928,5.21395981 11.7067277,4.71662113 L11.7,4.6 L11.7,1 C11.7,0.44771525 12.1477153,0 12.7,0 Z"
          id="Path"
        />
        <path
          d="M5.5,0 C6.01283584,0 6.43550716,0.38604019 6.49327227,0.883378875 L6.5,1 L6.5,4.6 C6.5,5.15228475 6.05228475,5.6 5.5,5.6 C4.98716416,5.6 4.56449284,5.21395981 4.50672773,4.71662113 L4.5,4.6 L4.5,1 C4.5,0.44771525 4.94771525,0 5.5,0 Z"
          id="Path"
        />
        <path
          d="M17.2,6.5 C17.7522847,6.5 18.2,6.94771525 18.2,7.5 C18.2,8.01283584 17.8139598,8.43550716 17.3166211,8.49327227 L17.2,8.5 L1,8.5 C0.44771525,8.5 -5.32907052e-15,8.05228475 -5.32907052e-15,7.5 C-5.32907052e-15,6.98716416 0.38604019,6.56449284 0.883378875,6.50672773 L1,6.5 L17.2,6.5 Z"
          id="Path"
        />
        <path
          d="M5.00447984,10 C5.55429044,10 6,10.4477153 6,11 C6,11.5128358 5.61568921,11.9355072 5.12057852,11.9932723 L5.00447984,12 C4.44570956,12 4,11.5522847 4,11 C4,10.4871642 4.38431079,10.0644928 4.87942148,10.0067277 L5.00447984,10 Z"
          id="Path"
        />
        <path
          d="M9.00447984,10 C9.55429044,10 10,10.4477153 10,11 C10,11.5128358 9.61568921,11.9355072 9.12057852,11.9932723 L9.00447984,12 C8.44570956,12 8,11.5522847 8,11 C8,10.4871642 8.38431079,10.0644928 8.87942148,10.0067277 L9.00447984,10 Z"
          id="Path"
        />
        <path
          d="M13.0044798,10 C13.5542904,10 14,10.4477153 14,11 C14,11.5128358 13.6156892,11.9355072 13.1205785,11.9932723 L13.0044798,12 C12.4457096,12 12,11.5522847 12,11 C12,10.4871642 12.3843108,10.0644928 12.8794215,10.0067277 L13.0044798,10 Z"
          id="Path"
        />
        <path
          d="M5.00447984,14 C5.55429044,14 6,14.4477153 6,15 C6,15.5128358 5.61568921,15.9355072 5.12057852,15.9932723 L5.00447984,16 C4.44570956,16 4,15.5522847 4,15 C4,14.4871642 4.38431079,14.0644928 4.87942148,14.0067277 L5.00447984,14 Z"
          id="Path"
        />
        <path
          d="M9.00447984,14 C9.55429044,14 10,14.4477153 10,15 C10,15.5128358 9.61568921,15.9355072 9.12057852,15.9932723 L9.00447984,16 C8.44570956,16 8,15.5522847 8,15 C8,14.4871642 8.38431079,14.0644928 8.87942148,14.0067277 L9.00447984,14 Z"
          id="Path"
        />
        <path
          d="M13.0044798,14 C13.5542904,14 14,14.4477153 14,15 C14,15.5128358 13.6156892,15.9355072 13.1205785,15.9932723 L13.0044798,16 C12.4457096,16 12,15.5522847 12,15 C12,14.4871642 12.3843108,14.0644928 12.8794215,14.0067277 L13.0044798,14 Z"
          id="Path"
        />
      </g>
    </g>
  </svg>
)

export const CreditCardIcon = () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="Icons/creditcard" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect id="Box-24pt" x="0" y="0" width="24" height="24" />
      <g id="credit-card" transform="translate(2.000000, 4.000000)" fill="#030F1C">
        <path
          d="M17,0 L3,0 C1.34314575,0 0,1.34314575 0,3 L0,12.0909091 C0,13.7477633 1.34314575,15.0909091 3,15.0909091 L17,15.0909091 C18.6568542,15.0909091 20,13.7477633 20,12.0909091 L20,3 C20,1.34314575 18.6568542,0 17,0 Z M3,2 L17,2 C17.5522847,2 18,2.44771525 18,3 L18,12.0909091 C18,12.6431938 17.5522847,13.0909091 17,13.0909091 L3,13.0909091 C2.44771525,13.0909091 2,12.6431938 2,12.0909091 L2,3 C2,2.44771525 2.44771525,2 3,2 Z"
          id="Rectangle"
        />
        <path
          d="M19,4.2 C19.5522847,4.2 20,4.64771525 20,5.2 C20,5.71283584 19.6139598,6.13550716 19.1166211,6.19327227 L19,6.2 L1,6.2 C0.44771525,6.2 0,5.75228475 0,5.2 C0,4.68716416 0.38604019,4.26449284 0.883378875,4.20672773 L1,4.2 L19,4.2 Z"
          id="Path"
        />
        <path
          d="M8.7,9 C8.86568542,9 9,9.44771525 9,10 C9,10.5128358 8.88418794,10.9355072 8.73498634,10.9932723 L8.7,11 L3.3,11 C3.13431458,11 3,10.5522847 3,10 C3,9.48716416 3.11581206,9.06449284 3.26501366,9.00672773 L3.3,9 L8.7,9 Z"
          id="Path"
        />
      </g>
    </g>
  </svg>
)

export const RetornabilityIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4501 1.8199C9.11886 0.576457 7.23702 0.0630898 5.43556 0.470693C3.57198 0.892351 2.05505 2.24062 1.41765 4.04186C1.30599 4.3574 1.47127 4.70372 1.78681 4.81538C2.10235 4.92704 2.44867 4.76176 2.56033 4.44621C3.05889 3.03733 4.24541 1.98274 5.70306 1.65293C7.16071 1.32312 8.68564 1.7642 9.74214 2.82124L11.1972 4.18872L9.42151 4.18897L9.35083 4.19305C9.04941 4.22806 8.81545 4.48422 8.81545 4.79503C8.81545 5.12975 9.08679 5.40109 9.42151 5.40109H12.7273L12.7278 5.40106C12.7508 5.40104 12.7738 5.39971 12.7966 5.39709L12.798 5.39701C12.8704 5.38861 12.9389 5.36744 13.0012 5.33583C13.0457 5.31328 13.088 5.28491 13.1268 5.25076C13.1661 5.21626 13.201 5.17677 13.2303 5.13326C13.2478 5.10727 13.2631 5.08024 13.2761 5.05245C13.3128 4.97432 13.3333 4.88707 13.3333 4.79503V1.48925L13.3293 1.41857C13.2943 1.11715 13.0381 0.883188 12.7273 0.883188L12.6566 0.887265C12.3552 0.922275 12.1212 1.17844 12.1212 1.48925V3.39389L10.5858 1.95113L10.4501 1.8199ZM3.91184 6.39282C4.24656 6.39282 4.5179 6.66416 4.5179 6.99888C4.5179 7.30969 4.28394 7.56585 3.98252 7.60086L3.91184 7.60494H2.1359L3.59119 8.97264C4.64769 10.0297 6.17263 10.4708 7.63028 10.141C9.08793 9.81114 10.2744 8.75655 10.773 7.34766C10.8847 7.03212 11.231 6.86684 11.5465 6.9785C11.8621 7.09016 12.0273 7.43648 11.9157 7.75202C11.2783 9.55326 9.76135 10.9015 7.89777 11.3232C6.09631 11.7308 4.21448 11.2174 2.88324 9.97398L2.74752 9.84275L1.21212 8.40001V10.3047C1.21212 10.6155 0.978157 10.8716 0.67674 10.9066L0.60606 10.9107C0.295251 10.9107 0.0390865 10.6768 0.00407741 10.3753L0 10.3047V6.99888C0 6.91832 0.0157181 6.84143 0.0442548 6.77111C0.067663 6.71333 0.100386 6.65836 0.142496 6.60845C0.152483 6.59661 0.162915 6.58515 0.173767 6.57411C0.230181 6.51664 0.295384 6.47275 0.365224 6.44256C0.41842 6.4195 0.475573 6.40384 0.535381 6.39689L0.536175 6.39685C0.559378 6.39417 0.582716 6.39282 0.60606 6.39282C0.6061 6.39282 0.606139 6.39282 0.606179 6.39282H3.91184Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.91184 6.39282C4.24656 6.39282 4.5179 6.66416 4.5179 6.99888C4.5179 7.30969 4.28394 7.56586 3.98252 7.60087L3.91184 7.60494H1.21212V10.3047C1.21212 10.6155 0.978157 10.8716 0.67674 10.9066L0.60606 10.9107C0.295251 10.9107 0.0390865 10.6768 0.00407741 10.3753L0 10.3047V6.99888C0 6.68807 0.233964 6.43191 0.535381 6.3969L0.60606 6.39282H3.91184Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.43561 0.470693C7.23707 0.0630898 9.11891 0.576457 10.4501 1.8199L10.5859 1.95113L13.1423 4.35333C13.3863 4.58254 13.3982 4.96609 13.169 5.21001C12.9574 5.43518 12.6143 5.46267 12.3709 5.28528L12.3123 5.23667L9.74219 2.82124C8.68569 1.7642 7.16076 1.32312 5.70311 1.65293C4.24545 1.98274 3.05894 3.03733 2.56038 4.44621C2.44872 4.76176 2.1024 4.92704 1.78686 4.81538C1.47131 4.70372 1.30603 4.3574 1.4177 4.04186C2.05509 2.24062 3.57203 0.892351 5.43561 0.470693Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.164394 6.58387C0.375969 6.35871 0.719057 6.33122 0.962442 6.5086L1.02108 6.55722L3.59119 8.97264C4.64769 10.0297 6.17263 10.4708 7.63028 10.141C9.08793 9.81114 10.2744 8.75656 10.773 7.34767C10.8847 7.03212 11.231 6.86684 11.5465 6.97851C11.8621 7.09017 12.0273 7.43648 11.9157 7.75203C11.2783 9.55326 9.76135 10.9015 7.89777 11.3232C6.09631 11.7308 4.21448 11.2174 2.88324 9.97398L2.74752 9.84275L0.191046 7.44055C-0.0528804 7.21135 -0.0648131 6.8278 0.164394 6.58387Z"
        fill="white"
      />
    </svg>
  )
}
